import { formatLimit } from './format_limit'

export const getFormatValuesToServerData = (eventType) => (values) => {
  const shouldSave = eventType.event_limit?.uuid || values.dailyLimit || values.weeklyLimit || values.monthlyLimit

  return shouldSave ? {
    event_limit_attributes: {
      daily_limit: formatLimit(values.dailyLimit),
      weekly_limit: formatLimit(values.weeklyLimit),
      monthly_limit: formatLimit(values.monthlyLimit)
    }
  } : {}
}
